function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M12 0a2 2 0 012 2v26.223a9.004 9.004 0 016.996 8.512L21 37h-.01c0 4.5 5.25 11 1.5 11-1.97 0-1.49-1-2.99-1-1.5 0-.932 1-2.5 1-2.5 0-1-3-3-3-3 0-1 3-4 3H9a1 1 0 01-1-1v-2.25a1.528 1.528 0 00-3-.41c-.075.268-.474 3.524-3.419 3.658-4.248-.12 1.41-5.06 1.41-10.998H3a9.003 9.003 0 017-8.777V2a2 2 0 012-2zm32.161 28a3.6 3.6 0 013.449 4.634l-3.84 12.8A3.6 3.6 0 0140.32 48h-7.51a3.6 3.6 0 01-3.493-2.727l-3.2-12.8A3.6 3.6 0 0129.611 28z",
  fill: "#262626"
}));

var SvgAddOnMoppingXLarge = function SvgAddOnMoppingXLarge(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgAddOnMoppingXLarge;